<template>
        <div class="modal" v-bind:class="{'is-active': show}">
                <div class="modal-background" @click="closeModal"></div>
                <div class="modal-card">
                        <header class="modal-card-head">
                                <p class="modal-card-title"><img src="/static/img/transparent.png" class="logo is-paddingless"> <span>{{ selected.title }}</span></p>
                                <button class="delete is-pulled-right" aria-label="close" @click="closeModal"></button>
                        </header>
                        <section class="modal-card-body">



                                <!--<hr>-->
                                <!--<div class="container">-->
                                        <div class="columns is-multiline">
                                                <div class="column">
                                                        <div class="content" v-html="selected.text">

                                                        </div>
                                                </div>
                                        </div>
                                <!--</div>-->

                                <!--<p class="subtitle">{{selected.description}}
                                        <a href="https://app.blablacommentz.com/dashboard/news/13" class="is-link"><u>Read more...</u></a>
                                </p>-->

                        </section>
                        <footer class="modal-card-foot has-text-centered">
                                <button :disabled="leftDisabled" class="button" @click="prev"><i class="fa fa-angle-left"></i></button>
                                <button :disabled="rightDisabled" class="button" @click="next"><i class="fa fa-angle-right"></i></button>
                                <span>{{i}} out of {{news.length}}</span>
                        </footer>
                </div>
        </div>
</template>
<script>

    import _ from 'lodash'
    import NewsRepo from '../../repos/NewsRepo'

    export default {
        name: 'news-modal',
        components: {},
        props:['show', 'news'],
        data() {
            return {
                selected: {},
                i: 1,
                repo: new NewsRepo(this.$auth),

            }
        },
        created(){

        },
        mounted(){
            if(this.news && this.news.length > 0){
                this.select();
            }
        },
        computed: {
          leftDisabled: function(){
              return this.i < 2
          },
          rightDisabled: function(){
            return this.i >= this.news.length
          }
        },
        methods: {
            closeModal(){
                this.$emit("onClose", {});
            },
            next(){
                this.i += 1;
                this.select();
            },
            prev(){
                this.i -= 1;
                this.select();
            },
            select(){
                this.selected = this.news[this.i - 1];
                let id = this.selected.id;

                this.repo.updateSeen(id).then(response => {
                    this.singleNews = response.data.data;
                    this.$parent.removeNews(id, false);
                }).catch((response) => {
                });

            }
        },
        watch: {
            news: function(val){
                this.select();
            }
        }

    }
</script>

<style lang="css" scoped>

        .hide-preview{
                display: none;
        }

        .logo{
                height: 36px !important;
                width: auto !important;
                margin-bottom: -8px;
                margin-right: 10px;
        }


        @media screen and (min-width: 769px){

                .modal-card {
                        width: 80%;
                }
        }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsModal.vue